import { resolveComponent as a, openBlock as l, createBlock as s, withCtx as c, createElementVNode as n, normalizeClass as x, renderSlot as b, toDisplayString as i, createCommentVNode as r, createElementBlock as y, withKeys as A, createTextVNode as w, createVNode as C, resolveDynamicComponent as B, Fragment as O, renderList as E, resolveDirective as R, withDirectives as q, vModelText as T, withModifiers as U } from "vue";
import { _ as D } from "./_plugin-vue_export-helper-dad06003.js";
import { B as $, b as M, c as V } from "./ButtonCloseSm-209b27c6.js";
import { F as X } from "./FormInput-50949de3.js";
import { L as I, i as P } from "./CardVideo-a346405d.js";
import { M as Ke } from "./CardVideo-a346405d.js";
import "./glightbox-13d8fc52.js";
import "./FormRichText.model-53e072ea.js";
import { M as j } from "./MagnifyingGlassIcon-14c73a3f.js";
import { L as N } from "./LoveIcon-2c34d5f1.js";
import { U as H, L as G, P as J, C as Q, a as W, b as Y, T as Z } from "./UserCircleSingleIcon-58049666.js";
import { S as tt } from "./ShippingBoxIcon-eeb16070.js";
import { C as et, a as K, b as F } from "./CardShortcutPrimary-6a7f3f4d.js";
import { A as ot } from "./AlertTriangleIcon-d613f6a8.js";
import { C as z } from "./CardShortcut-d8584bdc.js";
import { H as nt } from "./HelpIcon-2069ddad.js";
import { B as lt } from "./ButtonPrimaryErrorLg-ed6e962d.js";
import "./PreloaderIcon-b44be854.js";
import "./XIcon-e21df3cc.js";
import "./AlertCircleIcon-61966fff.js";
import "./CheckIcon-91388c05.js";
import "./BadgeGraySm-db599b39.js";
import "./string-d21d3f3f.js";
import "./useNotificationHandler.js";
import "./ButtonPlay-d3872713.js";
import "./DownloadFileIcon-8a003268.js";
import "./BarProgressMd-c3ebb73b.js";
import "./ChevronLeftIcon-b6affe9b.js";
import "./_commonjsHelpers-10dfc225.js";
const at = {
  components: {
    ButtonCloseSm: $,
    ButtonPrimaryLg: M,
    ButtonSecondaryLg: V,
    FormInput: X,
    LayoutModal: I
  },
  props: {
    inputError: { type: String, default: "" },
    modalData: {
      type: Object,
      default: () => ({})
    },
    open: Boolean,
    showXButton: {
      type: Boolean,
      default: !0
    },
    size: {
      type: String,
      default: "md"
    },
    text: { type: String, default: "" }
  },
  emits: ["update:open", "update:text", "cta", "cancel"],
  data() {
    return {
      isOpen: this.open
    };
  },
  computed: {
    inputData: {
      get() {
        return this.text;
      },
      set(e) {
        this.$emit("update:text", e);
      }
    }
  },
  watch: {
    open(e) {
      this.isOpen = !!e;
    }
  },
  methods: {
    handleCancelAction() {
      this.$emit("update:open", !1), this.$emit("cancel");
    }
  }
}, st = { class: "w-full flex items-start space-x-2" }, rt = { class: "w-full space-y-4" }, it = { class: "text-left flex-grow ct-text-1 text-lg font-semibold" }, dt = {
  key: 0,
  class: "text-left mt-1 ct-text-3 text-sm"
}, ct = { key: 0 }, ut = { class: "grid grid-cols-2 gap-3 mt-8" };
function mt(e, o, t, S, m, p) {
  const h = a("ButtonCloseSm"), d = a("FormInput"), f = a("ButtonSecondaryLg"), _ = a("ButtonPrimaryLg"), v = a("LayoutModal");
  return l(), s(v, {
    modelValue: m.isOpen,
    "onUpdate:modelValue": o[5] || (o[5] = (u) => m.isOpen = u),
    onClose: o[6] || (o[6] = (u) => e.$emit("update:open", !1))
  }, {
    default: c(() => [
      n("div", {
        class: x(["w-full border ct-border-1 ct-bg-1--alt rounded-xl flex flex-col shadow-xl p-6 text-left", `max-w-${t.size}`])
      }, [
        n("div", st, [
          n("div", rt, [
            b(e.$slots, "icon"),
            n("h2", it, i(t.modalData.title), 1)
          ]),
          t.showXButton ? (l(), s(h, {
            key: 0,
            class: "flex-shrink-0",
            onClick: p.handleCancelAction
          }, null, 8, ["onClick"])) : r("", !0)
        ]),
        t.modalData.description || e.$slots.default ? (l(), y("div", dt, [
          t.modalData.description ? (l(), y("p", ct, i(t.modalData.description), 1)) : r("", !0),
          b(e.$slots, "default")
        ])) : r("", !0),
        t.modalData.inputLabel ? (l(), s(d, {
          key: 1,
          modelValue: p.inputData,
          "onUpdate:modelValue": o[0] || (o[0] = (u) => p.inputData = u),
          class: "mt-5",
          title: t.modalData.inputLabel,
          error: t.inputError,
          autofocus: "",
          onKeydown: [
            o[1] || (o[1] = A((u) => e.$emit("cta"), ["enter"])),
            o[2] || (o[2] = A((u) => e.$emit("cancel"), ["esc"]))
          ]
        }, null, 8, ["modelValue", "title", "error"])) : r("", !0),
        b(e.$slots, "fields"),
        n("div", ut, [
          t.modalData.cancelLabel ? (l(), s(f, {
            key: 0,
            onClick: o[3] || (o[3] = (u) => e.$emit("cancel"))
          }, {
            default: c(() => [
              w(i(t.modalData.cancelLabel), 1)
            ]),
            _: 1
          })) : r("", !0),
          C(_, {
            loading: t.modalData.ctaLoading,
            onClick: o[4] || (o[4] = (u) => e.$emit("cta"))
          }, {
            default: c(() => [
              b(e.$slots, "ctaIcon"),
              n("span", null, i(t.modalData.ctaLabel), 1)
            ]),
            _: 3
          }, 8, ["loading"])
        ])
      ], 2)
    ]),
    _: 3
  }, 8, ["modelValue"]);
}
const Oe = /* @__PURE__ */ D(at, [["render", mt]]), ft = {
  components: {
    UserCircleSingleIcon: H,
    LoveIcon: N,
    LegalIcon: G,
    PlayerIcon: J,
    CookieIcon: Q,
    PricingIcon: W,
    PageIcon: Y,
    TimerIcon: Z,
    ShippingBoxIcon: tt,
    CardIconSm: et
  },
  props: {
    results: {
      type: Object,
      default: () => {
      }
    }
  },
  emits: ["close"],
  methods: {
    doAndClose(e) {
      e.handler && e.handler(), this.$emit("close");
    }
  }
}, pt = { class: "py-3 space-y-1" }, yt = { class: "flex-grow text-left text-sm font-medium ct-text-3" }, ht = { class: "text-left flex-grow text-sm overflow-hidden" }, _t = { class: "font-medium ct-text-1 truncate" }, gt = {
  key: 0,
  class: "ct-text-3 truncate"
}, xt = { key: 1 }, vt = { class: "text-left flex-grow text-sm overflow-hidden" }, bt = { class: "font-normal ct-text-3 truncate" };
function Ct(e, o, t, S, m, p) {
  const h = a("CardIconSm");
  return l(), y("div", pt, [
    t.results.hideFromSearch ? r("", !0) : (l(), s(B(t.results.link ? "a" : "div"), {
      key: 0,
      href: t.results.link,
      class: x(["pl-3 pr-5 flex items-center space-x-2 rounded-lg", [
        t.results.children ? "" : "cursor-pointer hover:ct-bg-1 focus:ct-bg-1 focus:outline-none"
      ]]),
      onClick: o[0] || (o[0] = (d) => p.doAndClose(t.results))
    }, {
      default: c(() => [
        t.results.icon ? (l(), s(h, {
          key: 0,
          type: "modern"
        }, {
          default: c(() => [
            (l(), s(B(t.results.icon), { class: "h-4 w-4" }))
          ]),
          _: 1
        })) : r("", !0),
        n("p", yt, i(t.results.label), 1)
      ]),
      _: 1
    }, 8, ["href", "class"])),
    n("ul", null, [
      (l(!0), y(O, null, E(t.results.children, (d) => (l(), y("li", {
        key: d.id,
        class: "px-2 py-0.5"
      }, [
        d.hideFromSearch ? r("", !0) : (l(), s(B(d.link ? "a" : "div"), {
          key: 0,
          href: d.link,
          class: "flex items-center space-x-2 cursor-pointer hover:ct-bg-1 focus:ct-bg-1 focus:outline-none rounded-lg p-3 pr-2.5",
          onClick: (f) => p.doAndClose(d)
        }, {
          default: c(() => [
            d.icon ? (l(), s(h, {
              key: 0,
              type: "modern"
            }, {
              default: c(() => [
                (l(), s(B(d.icon), { class: "h-4 w-4" }))
              ]),
              _: 2
            }, 1024)) : r("", !0),
            n("div", ht, [
              n("p", _t, i(d.label), 1),
              d.description ? (l(), y("p", gt, i(d.description), 1)) : r("", !0)
            ])
          ]),
          _: 2
        }, 1032, ["href", "onClick"])),
        d.children ? (l(), y("ul", xt, [
          (l(!0), y(O, null, E(d.children, (f) => (l(), y("li", {
            key: f.label,
            class: "px-2 py-0.5"
          }, [
            f.hideFromSearch ? r("", !0) : (l(), s(B(f.link ? "a" : "div"), {
              key: 0,
              href: f.link,
              class: "flex items-center space-x-2 cursor-pointer hover:ct-bg-1 focus:ct-bg-1 focus:outline-none rounded-lg p-3 pr-2.5",
              onClick: (_) => p.doAndClose(f)
            }, {
              default: c(() => [
                n("div", vt, [
                  n("p", bt, i(f.label), 1)
                ])
              ]),
              _: 2
            }, 1032, ["href", "onClick"]))
          ]))), 128))
        ])) : r("", !0)
      ]))), 128))
    ])
  ]);
}
const kt = /* @__PURE__ */ D(ft, [["render", Ct]]), wt = {
  name: "ResultsEmpty",
  props: {
    query: {
      type: String,
      default: ""
    },
    emptyLabel: {
      type: String,
      default: ""
    },
    emptyDescription: {
      type: String,
      default: ""
    }
  }
}, Dt = { class: "p-8" }, St = { class: "w-full max-w-sm text-base ct-text-3 whitespace-pre-line" }, Lt = { class: "ct-text-1" }, Bt = { class: "mt-4" };
function $t(e, o, t, S, m, p) {
  return l(), y("div", Dt, [
    n("div", St, [
      n("p", null, [
        w(i(t.emptyLabel) + " ", 1),
        n("span", Lt, "“" + i(t.query) + "”", 1),
        o[0] || (o[0] = w(". "))
      ]),
      n("p", Bt, i(t.emptyDescription), 1)
    ])
  ]);
}
const Vt = /* @__PURE__ */ D(wt, [["render", $t]]), It = {
  components: {
    LayoutModal: I,
    MagnifyingGlassIcon: j,
    ResultSection: kt,
    ResultsEmpty: Vt
  },
  props: {
    modalData: {
      type: Object,
      default: () => ({})
    },
    open: Boolean,
    query: { type: String, default: "" }
  },
  emits: ["update:open", "update:query"],
  data() {
    return {
      isOpen: this.open
    };
  },
  computed: {
    inputData: {
      get() {
        return this.query;
      },
      set(e) {
        this.$emit("update:query", e);
      }
    }
  },
  watch: {
    open(e) {
      this.isOpen = e;
    }
  },
  mounted() {
    this.$refs.input.focus(), document.addEventListener("keydown", this.shortcuts, !0);
  },
  beforeUnmount() {
    document.removeEventListener("keydown", this.shortcuts, !0);
  },
  methods: {
    hide() {
      this.$emit("update:open", !1);
    },
    shortcuts(e) {
      e.key === "ArrowDown" && this.focusNextElement();
    },
    focusNextElement() {
      const e = 'a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])', o = Array.from(document.querySelectorAll(e)), t = o.indexOf(document.activeElement);
      t > -1 && t < o.length - 1 && o[t + 1].focus();
    }
  }
}, Ot = { class: "max-h-[80vh] w-full max-w-md border ct-border-1 ct-bg-1 rounded-xl flex flex-col shadow-xl overflow-y-auto no-scrollbar" }, Et = { class: "rounded-xl pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3" }, Mt = ["placeholder"];
function Pt(e, o, t, S, m, p) {
  const h = a("MagnifyingGlassIcon"), d = a("ResultSection"), f = a("ResultsEmpty"), _ = a("LayoutModal"), v = R("click-outside");
  return l(), s(_, {
    modelValue: m.isOpen,
    "onUpdate:modelValue": o[2] || (o[2] = (u) => m.isOpen = u),
    "top-position": "",
    onClose: o[3] || (o[3] = (u) => e.$emit("update:open", !1))
  }, {
    default: c(() => {
      var u, g;
      return [
        q((l(), y("div", Ot, [
          n("div", {
            class: x(["relative", [t.query || (u = t.modalData.results) != null && u.length ? "border-b ct-border-2" : ""]])
          }, [
            n("div", Et, [
              C(h, {
                class: "h-5 w-5 ct-fg-4 mb-0.5",
                "aria-hidden": "true"
              })
            ]),
            q(n("input", {
              ref: "input",
              "onUpdate:modelValue": o[0] || (o[0] = (L) => p.inputData = L),
              class: "rounded-xl w-full ct-bg-1 py-4 px-12 space-x-2 ct-text-1 placeholder:ct-text-placeholder text-base border-0 ourline-0 focus:ring-0 focus:outline-0",
              placeholder: t.modalData.placeholder,
              autofocus: ""
            }, null, 8, Mt), [
              [T, p.inputData]
            ]),
            o[4] || (o[4] = n("div", { class: "absolute inset-y-0 right-0 flex items-center pr-3" }, [
              n("kbd", { class: "inline-flex items-center ct-bg-2--alt rounded border ct-border-2 px-1 py-0.5 font-sans text-xs ct-text-3" }, " Esc ")
            ], -1))
          ], 2),
          n("div", null, [
            (l(!0), y(O, null, E(t.modalData.results, (L, k) => (l(), s(d, {
              key: k,
              results: L,
              class: x([k !== t.modalData.results.length - 1 ? "border-b ct-border-2" : ""]),
              onClose: o[1] || (o[1] = (ne) => e.$emit("update:open", !1))
            }, null, 8, ["results", "class"]))), 128))
          ]),
          t.query && !((g = t.modalData.results) != null && g.length) ? (l(), s(f, {
            key: 0,
            query: t.query,
            "empty-label": t.modalData.emptyLabel,
            "empty-description": t.modalData.emptyDescription
          }, null, 8, ["query", "empty-label", "empty-description"])) : r("", !0)
        ])), [
          [v, p.hide]
        ])
      ];
    }),
    _: 1
  }, 8, ["modelValue"]);
}
const Ee = /* @__PURE__ */ D(It, [["render", Pt]]), At = {
  components: {
    ButtonCloseSm: $,
    ButtonPrimaryLg: M,
    ButtonSecondaryLg: V,
    LayoutModal: I,
    CardIcon: K,
    AlertTriangleIcon: ot,
    CardShortcutPrimary: F,
    CardShortcut: z
  },
  props: {
    modelValue: Boolean,
    modalData: {
      type: Object,
      default: () => ({})
    },
    showShortcut: {
      type: Boolean,
      default: !1
    },
    showXButton: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["update:modelValue", "cta", "cancel"],
  data() {
    return {
      isMaCOS: P(),
      isOpen: this.modelValue
    };
  },
  watch: {
    modelValue(e) {
      this.isOpen = e;
    }
  },
  mounted() {
    this.showShortcut && document.addEventListener("keydown", this.shortcuts, !0);
  },
  beforeUnmount() {
    this.showShortcut && document.removeEventListener("keydown", this.shortcuts, !0);
  },
  methods: {
    shortcuts(e) {
      (e.metaKey && e.shiftKey && e.key === "Enter" || e.ctrlKey && e.shiftKey && e.key === "Enter") && (e.stopPropagation(), e.preventDefault(), this.$emit("cta")), e.key === "Escape" && (e.stopPropagation(), e.preventDefault(), this.isOpen = !1);
    }
  }
}, qt = { class: "w-full flex items-start space-x-2" }, Ut = { class: "w-full space-y-4" }, Kt = { class: "text-left flex-grow ct-text-1 text-lg font-semibold" }, Ft = { class: "text-left mt-1 ct-text-3 text-sm" }, zt = { key: 0 };
function Rt(e, o, t, S, m, p) {
  const h = a("AlertTriangleIcon"), d = a("CardIcon"), f = a("ButtonCloseSm"), _ = a("CardShortcut"), v = a("ButtonSecondaryLg"), u = a("CardShortcutPrimary"), g = a("ButtonPrimaryLg"), L = a("LayoutModal");
  return l(), s(L, {
    modelValue: m.isOpen,
    "onUpdate:modelValue": o[3] || (o[3] = (k) => m.isOpen = k),
    onClose: o[4] || (o[4] = (k) => e.$emit("update:modelValue", !1))
  }, {
    default: c(() => [
      n("div", {
        class: x(["max-h-screen w-full border ct-border-1 ct-bg-1--alt rounded-xl flex flex-col shadow-xl p-6", `max-w-${t.modalData.size || "md"}`])
      }, [
        n("div", qt, [
          n("div", Ut, [
            C(d, { type: "warning" }, {
              default: c(() => [
                C(h)
              ]),
              _: 1
            }),
            n("h2", Kt, i(t.modalData.title), 1)
          ]),
          t.showXButton ? (l(), s(f, {
            key: 0,
            class: "flex-shrink-0",
            onClick: o[0] || (o[0] = (k) => m.isOpen = !1)
          })) : r("", !0)
        ]),
        n("div", Ft, [
          t.modalData.description ? (l(), y("p", zt, i(t.modalData.description), 1)) : r("", !0),
          b(e.$slots, "default")
        ]),
        n("div", {
          class: x(["grid gap-3 mt-8", [t.modalData.cancelLabel ? "grid-cols-2" : "grid-cols-1"]])
        }, [
          t.modalData.cancelLabel ? (l(), s(v, {
            key: 0,
            onClick: o[1] || (o[1] = (k) => e.$emit("cancel"))
          }, {
            default: c(() => [
              n("span", null, i(t.modalData.cancelLabel), 1),
              t.showShortcut ? (l(), s(_, { key: 0 }, {
                default: c(() => o[5] || (o[5] = [
                  w("ESC ")
                ])),
                _: 1
              })) : r("", !0)
            ]),
            _: 1
          })) : r("", !0),
          C(g, {
            loading: t.modalData.ctaLoading,
            onClick: o[2] || (o[2] = (k) => e.$emit("cta"))
          }, {
            default: c(() => [
              n("span", null, i(t.modalData.ctaLabel), 1),
              t.showShortcut ? (l(), s(u, { key: 0 }, {
                default: c(() => [
                  w(i(m.isMaCOS ? "⌘" : "Ctrl") + " ⇧ ⏎", 1)
                ]),
                _: 1
              })) : r("", !0)
            ]),
            _: 1
          }, 8, ["loading"])
        ], 2)
      ], 2)
    ]),
    _: 3
  }, 8, ["modelValue"]);
}
const Me = /* @__PURE__ */ D(At, [["render", Rt]]), Tt = {
  name: "ModalDanger",
  components: {
    ButtonCloseSm: $,
    ButtonPrimaryErrorLg: lt,
    ButtonSecondaryLg: V,
    LayoutModal: I,
    CardIcon: K,
    HelpIcon: nt
  },
  props: {
    modalData: {
      type: Object,
      default: () => ({})
    },
    modelValue: Boolean,
    showXButton: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["update:modelValue", "cta", "cancel"],
  data() {
    return {
      isMaCOS: P(),
      isOpen: this.modelValue
    };
  },
  watch: {
    modelValue(e) {
      this.isOpen = e;
    }
  }
}, Xt = { class: "w-full flex items-start space-x-2" }, jt = { class: "w-full space-y-4" }, Nt = { class: "text-left flex-grow ct-text-1 text-lg font-semibold" }, Ht = { class: "text-left mt-1 ct-text-3 text-sm" }, Gt = { key: 0 };
function Jt(e, o, t, S, m, p) {
  const h = a("HelpIcon"), d = a("CardIcon"), f = a("ButtonCloseSm"), _ = a("ButtonSecondaryLg"), v = a("ButtonPrimaryErrorLg"), u = a("LayoutModal");
  return l(), s(u, {
    modelValue: m.isOpen,
    "onUpdate:modelValue": o[3] || (o[3] = (g) => m.isOpen = g),
    onClose: o[4] || (o[4] = (g) => e.$emit("update:modelValue", !1))
  }, {
    default: c(() => [
      n("div", {
        class: x(["max-h-screen w-full border ct-border-1 ct-bg-1--alt rounded-xl flex flex-col shadow-xl p-6", `max-w-${t.modalData.size || "md"}`])
      }, [
        n("div", Xt, [
          n("div", jt, [
            C(d, { type: "error" }, {
              default: c(() => [
                e.$slots.icon ? b(e.$slots, "icon", { key: 0 }) : (l(), s(h, { key: 1 }))
              ]),
              _: 3
            }),
            n("h2", Nt, i(t.modalData.title), 1)
          ]),
          C(f, {
            class: "flex-shrink-0",
            onClick: o[0] || (o[0] = (g) => m.isOpen = !1)
          })
        ]),
        n("div", Ht, [
          t.modalData.description ? (l(), y("p", Gt, i(t.modalData.description), 1)) : r("", !0),
          b(e.$slots, "default")
        ]),
        n("div", {
          class: x(["grid gap-3 mt-8", [t.modalData.cancelLabel ? "grid-cols-2" : "grid-cols-1"]])
        }, [
          t.modalData.cancelLabel ? (l(), s(_, {
            key: 0,
            onClick: o[1] || (o[1] = U((g) => e.$emit("cancel"), ["stop"]))
          }, {
            default: c(() => [
              n("span", null, i(t.modalData.cancelLabel), 1)
            ]),
            _: 1
          })) : r("", !0),
          C(v, {
            loading: t.modalData.ctaLoading,
            onClick: o[2] || (o[2] = U((g) => e.$emit("cta"), ["stop"]))
          }, {
            default: c(() => [
              n("span", null, i(t.modalData.ctaLabel), 1)
            ]),
            _: 1
          }, 8, ["loading"])
        ], 2)
      ], 2)
    ]),
    _: 3
  }, 8, ["modelValue"]);
}
const Pe = /* @__PURE__ */ D(Tt, [["render", Jt]]), Qt = {
  components: {
    ButtonCloseSm: $,
    ButtonPrimaryLg: M,
    ButtonSecondaryLg: V,
    CardShortcutPrimary: F,
    CardShortcut: z
  },
  props: {
    modalData: {
      type: Object,
      default: () => ({})
    },
    modelValue: {
      type: Boolean
    },
    showShortcut: {
      type: Boolean,
      default: !1
    },
    showXButton: {
      type: Boolean,
      default: !0
    },
    size: {
      type: String,
      default: "md"
    }
  },
  emits: ["update:modelValue", "cta", "cancel", "close"],
  data() {
    return {
      isMaCOS: P()
    };
  },
  mounted() {
    this.showShortcut && document.addEventListener("keydown", this.shortcuts, !0);
  },
  beforeUnmount() {
    this.showShortcut && document.removeEventListener("keydown", this.shortcuts, !0);
  },
  methods: {
    shortcuts(e) {
      (e.metaKey && e.shiftKey && e.key === "Enter" || e.ctrlKey && e.shiftKey && e.key === "Enter") && (e.stopPropagation(), e.preventDefault(), this.$emit("cta")), e.key === "Escape" && (e.stopPropagation(), e.preventDefault(), this.$emit("close"));
    },
    handleCancelAction() {
      this.$emit("update:modelValue", !1), this.$emit("close");
    }
  }
}, Wt = { class: "w-full flex items-start space-x-2" }, Yt = { class: "w-full space-y-4" }, Zt = { class: "text-left flex-grow ct-text-1 text-lg font-semibold" }, te = { class: "text-left mt-1 ct-text-3 text-sm" }, ee = { key: 0 };
function oe(e, o, t, S, m, p) {
  const h = a("ButtonCloseSm"), d = a("CardShortcut"), f = a("ButtonSecondaryLg"), _ = a("CardShortcutPrimary"), v = a("ButtonPrimaryLg");
  return l(), y("div", {
    class: x(["max-h-screen w-full border ct-border-1 ct-bg-1--alt rounded-xl flex flex-col shadow-xl p-6", `max-w-${t.size}`])
  }, [
    n("div", Wt, [
      n("div", Yt, [
        b(e.$slots, "icon"),
        n("h2", Zt, i(t.modalData.title), 1)
      ]),
      t.showXButton ? (l(), s(h, {
        key: 0,
        class: "flex-shrink-0",
        onClick: p.handleCancelAction
      }, null, 8, ["onClick"])) : r("", !0)
    ]),
    n("div", te, [
      t.modalData.description ? (l(), y("p", ee, i(t.modalData.description), 1)) : r("", !0),
      b(e.$slots, "default")
    ]),
    n("div", {
      class: x(["grid gap-3 mt-8", [t.modalData.cancelLabel ? "grid-cols-2" : "grid-cols-1"]])
    }, [
      t.modalData.cancelLabel ? (l(), s(f, {
        key: 0,
        onClick: o[0] || (o[0] = (u) => e.$emit("cancel"))
      }, {
        default: c(() => [
          n("span", null, i(t.modalData.cancelLabel), 1),
          t.showShortcut ? (l(), s(d, { key: 0 }, {
            default: c(() => o[2] || (o[2] = [
              w("ESC ")
            ])),
            _: 1
          })) : r("", !0)
        ]),
        _: 1
      })) : r("", !0),
      C(v, {
        loading: t.modalData.ctaLoading,
        onClick: o[1] || (o[1] = (u) => e.$emit("cta"))
      }, {
        default: c(() => [
          n("span", null, i(t.modalData.ctaLabel), 1),
          t.showShortcut ? (l(), s(_, { key: 0 }, {
            default: c(() => [
              w(i(m.isMaCOS ? "⌘" : "Ctrl") + " ⇧ ⏎", 1)
            ]),
            _: 1
          })) : r("", !0)
        ]),
        _: 1
      }, 8, ["loading"])
    ], 2)
  ], 2);
}
const Ae = /* @__PURE__ */ D(Qt, [["render", oe]]);
export {
  Me as ModalConfirm,
  Pe as ModalDanger,
  Ke as ModalDefault,
  Ae as ModalDefaultInner,
  Oe as ModalInput,
  Ee as ModalSearch
};
